export class TimerFormatter {
  static lotteryTimerFormatter(date: string) {
    const now = new Date(date.toString());
    const month =
      now.getMonth() + 1 < 10 ? "0" + now.getMonth() + 1 : now.getMonth() + 1;
    const day = now.getDate() < 10 ? "0" + now.getDate() : now.getDate();
    const hour = now.getHours() < 10 ? "0" + now.getHours() : now.getHours();
    const minu =
      now.getMinutes() < 10 ? "0" + now.getMinutes() : now.getMinutes();
    return month + "月" + day + "日" + " " + hour + ":" + minu;
  }
  static adLotteryTimerFormatter(date: string) {
    const now = new Date(date.toString());
    const month =
      now.getMonth() + 1 < 10 ? "0" + now.getMonth() + 1 : now.getMonth() + 1;
    if (isNaN(now.getMonth())) {
      return date;
    }
    const day = now.getDate() < 10 ? "0" + now.getDate() : now.getDate();
    if (isNaN(now.getDate())) {
      return date;
    }
    return month + "." + day;
  }

  static dateFormat() {
    const fdate = new Date()
    const year = fdate.getFullYear()
    const month = (fdate.getMonth() + 1) < 10 ? '0' + (fdate.getMonth() + 1) : (fdate.getMonth() + 1)
    const day = (fdate.getDate()) < 10 ? '0' + fdate.getDate() : fdate.getDate()
    const resDate = year + '-' + month + '-' + day
    return resDate
  }

  static lastDateFormat() {
    const yesterday = new Date();
    const yesterdayMilliseconds = yesterday.getTime() - 1000 * 60 * 60 * 24;
    yesterday.setTime(yesterdayMilliseconds);
    const year = yesterday.getFullYear();
    const month = (yesterday.getMonth() + 1) < 10 ? '0' + (yesterday.getMonth() + 1) : (yesterday.getMonth() + 1)
    const day = yesterday.getDate() < 10 ? '0' + yesterday.getDate() : yesterday.getDate()
    const resDate = year + '-' + month + '-' + day
    return resDate
  }
}
